import React, {useState, useEffect} from 'react';
import {useUserDetails} from '../../hooks/useUserDetails';
import './AgencyWarningModalLayout.scss';
import {useNavigate} from 'react-router-dom';
import routes from '../../utils/routes';
import {setLoader} from '../../store/builder/reducer';
import {logoutUser} from '../../store/builder/loginSlice';
import {useDispatch} from 'react-redux';

const AgencyWarningModal = ({children}) => {
  const dispatch = useDispatch();
  const hasToken = localStorage.getItem('ndx_user_token');
  const {error} = useUserDetails({enabled: !!hasToken});
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (error?.response?.status === 406) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [error]);

  const onIgnore = () => {
    dispatch(setLoader(true));
    dispatch(logoutUser());
    dispatch(setLoader(false));
    setIsOpen(false);
  };

  const onRefresh = () => {
    const keysToKeep = ['ndx_user_token', 'inspection_deviceId'];
    Object.keys(localStorage).forEach(key => {
      if (!keysToKeep.includes(key)) {
        localStorage.removeItem(key);
      }
    });
    navigate(routes.private.main);
    window.location.reload();
  };

  if (isOpen) {
    return (
      <div className='agency-warning-modal__overlay'>
        <div className='agency-warning-modal__container'>
          <h2 className='agency-warning-modal__title'>
            There's a Problem With Your FBO
          </h2>
          <div className='agency-warning-modal__warning'>
            <svg
              className='agency-warning-modal__warning-icon'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
              viewBox='0 0 24 24'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M12 9v2m0 4h.01M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z'
              />
            </svg>
            <div>
              <span className='agency-warning-modal__warning-text'>
                We couldn't find your FBO – It may have been deleted or
                unassigned.
              </span>
            </div>
          </div>
          <p className='agency-warning-modal__description'>
            Please reach out to your admin or support team.
          </p>
          <div className='agency-warning-modal__actions'>
            <button
              className='agency-warning-modal__button agency-warning-modal__button--secondary'
              onClick={onIgnore}
            >
              Logout
            </button>
            <button
              className='agency-warning-modal__button agency-warning-modal__button--primary'
              onClick={onRefresh}
            >
              Refresh
            </button>
          </div>
          <ul className='agency-warning-modal__help-list'>
            <li>
              <span className='highlight'>Ignore</span> – When the admin fixes
              the problems, you can click on the button to get to the main page
              and continue using the application.
            </li>
            <li>
              <span className='highlight'>Refresh</span> – Restart the app and
              start with new settings
            </li>
          </ul>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default AgencyWarningModal;
